import React, { useEffect, useState } from "react";
import { Col, Row, Form, Button } from "reactstrap";
import TextInput from "../../../components/InputFields/TextInput";
import DatePickerSelector from "../../../components/InputFields/DatePicker";
import { relationShipOptions, yesNoOptions, formikHouseHoldPatient } from "../Constant";
import { useFormik } from "formik";
import moment from "moment";
import { updatePatientById } from "../../../api/patient";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../../utils/Tostify";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";

const AddHouseHold = ({ patientDeatils, toggleTab }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  const navigate = useNavigate();
  const { getConfirmation } = useConfirmDialog();

  const formik = useFormik({
    ...formikHouseHoldPatient,
    onSubmit: async (values) => {
      let payload = { ...values };
      let res;
      try {
        setIsLoading(true);
        res = await updatePatientById({
          payload,
          dispatch,
          token,
          patientId: patientDeatils._id
        });
        setIsLoading(false);
        if (res?.status === "SUCCESS") {
          navigate("/clinic/patient-profile", {
            state: { patientData: patientDeatils?._id }
          });
          success(res?.message);
        } else {
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  useEffect(() => {
    if (patientDeatils) {
      const decryptedMembers = patientDeatils.relationship || [];
      formik.setValues({
        houseHoldSize: decryptedMembers.length + 1 || 1,
        houseHoldIncome: patientDeatils.houseHoldIncome || null,
        members: decryptedMembers.length > 0 ? decryptedMembers : formik.initialValues.members
      });
    }
  }, [patientDeatils]);

  const addFamilyMember = () => {
    formik.setFieldValue("members", [
      ...formik.values.members,
      { fullName: "", relationship: "", dob: "", dependent: "" }
    ]);
    formik.setFieldValue("houseHoldSize", formik.values.houseHoldSize + 1);
  };

  const removeFamilyMember = async (index) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: "Are you sure you want to remove this family member?"
    });

    if (confirmed) {
      let updatedMembers = [...formik.values.members];
      updatedMembers.splice(index, 1); // Remove the selected member

      let payload = {
        ...formik.values,
        members: updatedMembers,
        houseHoldSize: formik.values.houseHoldSize - 1
      };

      try {
        setIsLoading(true);
        const res = await updatePatientById({
          payload,
          dispatch,
          token,
          patientId: patientDeatils._id
        });
        setIsLoading(false);

        if (res?.status === "SUCCESS") {
          formik.setFieldValue("members", updatedMembers);
          formik.setFieldValue("houseHoldSize", payload.houseHoldSize);
          success(res?.message);
        } else {
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed("Failed to remove family member.");
      }
    }
  };

  useEffect(() => {
  if (patientDeatils) {
    const decryptedMembers = patientDeatils.relationship || [];
    formik.setValues({
      houseHoldSize: decryptedMembers.length + 1 || 1,
      houseHoldIncome:
        patientDeatils.houseHoldIncome === null || patientDeatils.houseHoldIncome === undefined
          ? ""
          : patientDeatils.houseHoldIncome,
      members: decryptedMembers.length > 0 ? decryptedMembers : formik.initialValues.members
    });
  }
}, [patientDeatils]);

  return (
    <div>
      {isLoading && <Loader />}
      <Form onSubmit={formik.handleSubmit}>
        <Row className="mt-3 align-items-center">
          <Col sm={6}>
            <p>HouseHold Size : {formik.values.houseHoldSize}</p>
          </Col>
          <Col sm={6}>
            <TextInput
              keyField="houseHoldIncome"
              formik={formik}
              required={false}
              label="Total Household Income (USD yearly)"
              type="text"
              value={
                formik.values.houseHoldIncome === null || formik.values.houseHoldIncome === undefined
                  ? ""
                  : formik.values.houseHoldIncome
              }
              onChange={(e) => {
                const value = e.target.value;
                // If user clears field, keep as empty string; else convert to number
                if (value === "") {
                  formik.setFieldValue("houseHoldIncome", "");
                } else {
                  const numberValue = Number(value);
                  formik.setFieldValue("houseHoldIncome", isNaN(numberValue) ? "" : numberValue);
                }
              }}
            />
          </Col>

        </Row>

        {formik.values.members.map((member, index) => (
          <div className="first_tab_blk mb-4" key={index}>
            <Row className="align-items-center">
              <Col xs={12} sm={6} md={4} lg={3}>
                <TextInput
                  keyField={`members[${index}].fullName`}
                  formik={formik}
                  label="Full Name"
                  type="text"
                  value={member.fullName}
                  onChange={(e) => formik.setFieldValue(`members[${index}].fullName`, e.target.value)}
                  disabled={index === 0} // Patient cannot be edited
                />
               {formik.touched.members?.[index]?.fullName && formik.errors.members?.[index]?.fullName && (
                <div style={{ color: "red", fontSize: "16px", marginTop: "5px" }}>
                  {formik.errors.members[index].fullName}
                </div>
              )}
              </Col>
              <Col xs={12} sm={6} md={4} lg={3} className="modal_pro_file">
                <DatePickerSelector
                  keyField={`members[${index}].dob`}
                  formik={formik}
                  value={member.dob}
                  maxDate={moment()}
                  label="Date Of Birth"
                  onChange={(e) => formik.setFieldValue(`members[${index}].dob`, moment(e).format("MM-DD-YYYY"))}
                  disabled={index === 0} // Patient cannot be edited
                />
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <TextInput
                  keyField={`members[${index}].relationship`}
                  formik={formik}
                  type="select"
                  label="Relationship"
                  options={relationShipOptions}
                  value={member.relationship}
                  onChange={(e) => formik.setFieldValue(`members[${index}].relationship`, e.target.value)}
                  disabled={index === 0} // Patient is always "Self"
                />
               {formik.touched.members?.[index]?.relationship && formik.errors.members?.[index]?.relationship && (
                <div style={{ color: "red", fontSize: "16px", marginTop: "5px" }}>
                  {formik.errors.members[index].relationship}
                </div>
              )}
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <TextInput
                  keyField={`members[${index}].dependent`}
                  formik={formik}
                  label="Dependent"
                  type="select"
                  options={yesNoOptions}
                  value={member.dependent}
                  onChange={(e) => formik.setFieldValue(`members[${index}].dependent`, e.target.value)}
                />
                {formik.touched.members?.[index]?.dependent && formik.errors.members?.[index]?.dependent && (
                  <div style={{ color: "red", fontSize: "16px", marginTop: "5px" }}>
                    {formik.errors.members[index].dependent}
                  </div>
                )}
              </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                  <Button color="danger" onClick={() => removeFamilyMember(index)}>
                  <i className="fas fa-trash-alt"></i>
                  </Button>
                </Col>
            </Row>
          </div>
        ))}

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button color="danger" onClick={addFamilyMember}>
            Add Family Member
          </Button>
        </div>

        <div className="d-flex justify-content-center gap-3 my-3">
          <button
            className="save_btn_blockk"
            type="button"
            onClick={() => {
              patientDeatils?._id
                ? navigate("/clinic/patient-profile", { state: { patientData: patientDeatils?._id } })
                : navigate("/clinic/patient-list");
            }}
          >
            Cancel
          </button>
          <button className="save_btn_blockk saving" type="submit">
            Save
          </button>
        </div>
      </Form>
    </div>
  );
};

export default AddHouseHold;

